(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1708],{

/***/ 47178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kA": function() { return /* reexport */ CompareButtonBox; },
  "y8": function() { return /* reexport */ CompareTextBox; },
  "W2": function() { return /* binding */ Container; },
  "jb": function() { return /* binding */ DescriptionContent; },
  "_O": function() { return /* binding */ DescriptionWrap; },
  "kC": function() { return /* binding */ Flex; },
  "es": function() { return /* binding */ LineBox; },
  "t3": function() { return /* binding */ LineHeader; },
  "ug": function() { return /* binding */ NoteBox; },
  "Ar": function() { return /* binding */ SubTitleWrap; },
  "Xr": function() { return /* reexport */ layout_WarningBox; }
});

// UNUSED EXPORTS: ProdutList, Stack

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
;// CONCATENATED MODULE: ./components/style/detailpackage/couponselect.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 20px;\n	font-size: var(--derault-size);\n	font-weight: normal;\n	color: var(--emp-color);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 20px 30px;\n	border: 1px solid var(--line-color);\n	+ h4 {\n		margin-top: 40px;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-size: var(--default-size);\n	+ li {\n		margin-top: 10px;\n	}\n	> div {\n		line-height: 1;\n	}\n	label {\n		display: flex;\n		align-items: center;\n		input {\n			flex: 0 0 auto;\n		}\n		> span {\n			em {\n				line-height: 1.6;\n				&::after {\n					display: inline-block;\n					width: 1px;\n					height: 12px;\n					margin: 0 10px;\n					background-color: var(--line-color);\n					content: "";\n				}\n			}\n		}\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: inline-block;\n	width: fit-content;\n	line-height: 1;\n	margin-left: 10px;\n	&::before {\n		position: absolute;\n		bottom: -2px;\n		display: inline-block;\n		width: 100%;\n		height: 1px;\n		background-color: var(--default-color);\n		content: "";\n	}\n	&::after {\n		position: absolute;\n		top: 3px;\n		right: -22px;\n		display: inline-block;\n		width: 15px;\n		height: 14px;\n		background: url(',
        ') no-repeat;\n		background-position: -145px 0;\n		content: "";\n	}\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1;\n	color: var(--blue-color);\n	text-decoration: underline;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	margin-top: 40px;\n	text-align: center;\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n	> span {\n		margin-left: 10px;\n		font-size: var(--default-size);\n		color: var(--red-color);\n		em {\n			font-size: 22px;\n		}\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin: 40px auto 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 40px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 10px;\n	li + li {\n		margin-top: 8px;\n	}\n	li {\n		> ul {\n			margin-top: 10px;\n		}\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Title = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-72595239-0"
})(_templateObject());
var CouponList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-72595239-1"
})(_templateObject1());
var CouponItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-72595239-2"
})(_templateObject2());
var DownloadLink = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-72595239-3"
})(_templateObject3(), (ico_spr_default()));
var LinkText = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-72595239-4"
})(_templateObject4());
var TotalPrice = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-72595239-5"
})(_templateObject5());
var SubmitButtonBlock = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-72595239-6"
})(_templateObject6());
var NoteBoxWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-72595239-7"
})(_templateObject7());
var BulletList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-72595239-8"
})(_templateObject8());


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./framework/ui/desktop/layout/CompareBox.tsx



function CompareBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 0;\n	z-index: 1;\n	display: flex;\n	gap: 8px;\n	width: 100%;\n	height: 100%;\n	background-color: rgba(0, 0, 0, 0.5);\n	text-align: center;\n	align-items: center;\n	justify-content: center;\n"
    ]);
    CompareBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompareBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 14px;\n	color: #fff;\n	line-height: 1.7;\n"
    ]);
    CompareBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompareBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 38px;\n	padding: 0 30px;\n	border: 1px solid #fff;\n	background-color: transparent;\n	color: #fff;\n	line-height: 1.5;\n"
    ]);
    CompareBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompareBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 38px;\n	padding: 0 30px;\n	border: none;\n	background-color: var(--emp-color);\n	color: #fff;\n	line-height: 1.5;\n"
    ]);
    CompareBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9be5535c-0"
})(CompareBox_templateObject());
var Text = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-9be5535c-1"
})(CompareBox_templateObject1());
var DeselectButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-9be5535c-2"
})(CompareBox_templateObject2());
var CompareButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-9be5535c-3"
})(CompareBox_templateObject3());
var CompareTextBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
            children: [
                "비교할 상품을 선택해주세요.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 총 3개까지 선택하여",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 비교하실 수 있습니다."
            ]
        })
    });
};
var CompareButtonBox = function(param) {
    var compare = param.compare, clear = param.clear;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeselectButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "button"
            }, clear), {
                children: "선택 해제"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "button"
            }, compare), {
                children: "상품 비교"
            }))
        ]
    });
};


;// CONCATENATED MODULE: ./framework/ui/desktop/layout/WarningBox.tsx

function WarningBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	min-height: 600px;\n	text-align: center;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 30px;\n\n	&:before {\n		display: block;\n		width: 60px;\n		height: 60px;\n		background: url(",
        ') 0 -44px / 400px 400px no-repeat;\n		content: "";\n	}\n\n	p {\n		font-size: 15px;\n		color: var(--emp-color);\n	}\n'
    ]);
    WarningBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-679ae408-0"
})(WarningBox_templateObject(), (ico_spr_default()));
var WarningBox = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: children
        })
    });
};
/* harmony default export */ var layout_WarningBox = (WarningBox);

;// CONCATENATED MODULE: ./framework/ui/desktop/layout/index.tsx

function layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 0 auto;\n	padding-bottom: 100px;\n"
    ]);
    layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function layout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: ",
        ";\n	flex-direction: ",
        ";\n	justify-content: ",
        ";\n	gap: ",
        "px;\n	line-height: ",
        ";\n	flex-wrap: ",
        ";\n	flex-grow: ",
        ";\n"
    ]);
    layout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function layout_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 100%;\n	padding: 15px 0;\n	border-bottom: 2px solid var(--emp-color);\n	line-height: 1.25;\n	align-items: baseline;\n"
    ]);
    layout_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function layout_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 30px 0;\n	border-top: 1px solid var(--line-color);\n"
    ]);
    layout_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function layout_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	line-height: 1;\n	flex-direction: row;\n	align-items: baseline;\n"
    ]);
    layout_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function layout_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    layout_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function layout_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n"
    ]);
    layout_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function layout_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 910px;\n"
    ]);
    layout_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function layout_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1.6;\n	margin-top: 20px;\n	max-height: ",
        ";\n	overflow: hidden;\n\n	> div {\n		",
        "\n	}\n\n	/* pc */\n	@media (min-width: 736px) {\n		border: 1px solid var(--line-color);\n		padding: 35px 40px 40px;\n		box-sizing: border-box;\n	}\n"
    ]);
    layout_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	line-height: 1.6;\n	padding: 38px 40px 36px;\n	background-color: #f3f3f3;\n	font-size: var(--default-size);\n\n	h4,\n	p {\n		padding-left: 28px;\n		color: var(--emp-color);\n	}\n\n	h4 {\n		position: relative;\n		margin-bottom: 5px;\n\n		&:before {\n			position: absolute;\n			left: 0;\n			top: 50%;\n			display: block;\n			width: 18px;\n			height: 18px;\n			transform: translateY(-50%);\n			content: "";\n		}\n	}\n\n	p {\n		line-height: 1.6;\n	}\n\n	',
        "\n\n	",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-0"
})(layout_templateObject());
var Flex = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-1"
})(layout_templateObject1(), function(props) {
    return props.align;
}, function(props) {
    return props.direction ? "column" : "row";
}, function(props) {
    return props.justify;
}, function(props) {
    return props.gap ? props.gap : "0";
}, function(props) {
    return props.lineHeight;
}, function(props) {
    return props.wrap;
}, function(props) {
    return props.grow;
});
var LineHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-2"
})(layout_templateObject2());
var ProdutList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-9ed24f4e-3"
})(layout_templateObject3());
var Stack = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-4"
})(layout_templateObject4());
var SubTitleWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-5"
})(layout_templateObject5());
var DescriptionWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-6"
})(layout_templateObject6());
var DescriptionContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-7"
})(layout_templateObject7());
var LineBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-8"
})(layout_templateObject8(), function(props) {
    return props.elementHeight;
}, function(props) {
    return props.elementHeight && props.elementHeight !== "auto" ? "\n					max-height: 245px;\n				" : "";
});
var NoteBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-9"
})(_templateObject9(), function(props) {
    return props.icon === "point" && "\n		h4 {\n			&:before {\n				background: url(".concat((ico_spr_default()), ") no-repeat 0px -328px;\n			}\n		}\n	");
}, function(props) {
    return props.icon === "question" && "\n		h4 {\n			&:before {\n				height: 19px;\n				background: url(".concat((ico_spr_default()), ") no-repeat 0 -266px;\n			}\n		}\n	");
});





/***/ }),

/***/ 73255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yx": function() { return /* reexport */ list_BulletListItem; },
  "fe": function() { return /* reexport */ list_StackList; },
  "jS": function() { return /* reexport */ list_StackListItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./framework/ui/desktop/list/StackList.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	font-size: 14px;\n	color: var(--gray-color);\n	align-items: center;\n\n	li {\n		cursor: ",
        ";\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StackList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-232a0cb2-0"
})(_templateObject(), function(props) {
    return props.cursor ? "pointer" : "auto";
});
/* harmony default export */ var list_StackList = (StackList);

;// CONCATENATED MODULE: ./framework/ui/desktop/list/StackListItem.tsx

function StackListItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding: 0 20px;\n	color: var(--gray-color);\n	line-height: 1;\n\n	",
        '\n\n	&::after {\n		position: absolute;\n		top: 50%;\n		left: 0;\n		width: 1px;\n		height: 12px;\n		background-color: var(--line-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	&:first-child {\n		&:after {\n			display: none;\n		}\n	}\n\n	&:last-child {\n		padding-right: 0;\n	}\n'
    ]);
    StackListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StackListItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-fb0839f9-0"
})(StackListItem_templateObject(), function(props) {
    return props.isActive && "\n		color: var(--emp-color);\n	";
});
/* harmony default export */ var list_StackListItem = (StackListItem);

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./framework/ui/desktop/list/BulletListItem.tsx

function BulletListItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				color: var(--blue-color);\n			"
    ]);
    BulletListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				color: var(--red-color);\n			"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-left: 12px;\n	font-size: var(--basic-size);\n	color: var(--default-color);\n	word-break: keep-all;\n\n	&::before {\n		position: absolute;\n		top: 8px;\n		left: 0;\n		display: block;\n		width: 4px;\n		height: 4px;\n		border-radius: 50%;\n		background: var(--bl-color);\n		content: "";\n	}\n\n	a {\n		text-decoration: underline;\n	}\n\n	',
        "\n	",
        "\n\n    strong {\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


// 필요한 color 있으면 추가해서 사용
var Item = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-272fa6a0-0"
})(_templateObject2(), function(props) {
    if (props.color === "blue") {
        return (0,styled_components_browser_esm.css)(BulletListItem_templateObject());
    }
}, function(props) {
    if (props.color === "red") {
        return (0,styled_components_browser_esm.css)(_templateObject1());
    }
});
var BulletListItem = function(param) {
    var children = param.children, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
        color: color,
        children: children
    });
};
/* harmony default export */ var list_BulletListItem = (BulletListItem);

;// CONCATENATED MODULE: ./framework/ui/desktop/list/index.ts





/***/ }),

/***/ 5540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ table_Table; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./framework/ui/desktop/table/Table.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					th,\n					td {\n						text-align: left;\n						&.line-right {\n							border-right: 1px solid var(--line-color);\n						}\n					}\n					th {\n						padding: 0 20px;\n						label {\n							position: relative;\n						}\n					}\n					td {\n						padding: 10px 20px;\n					}\n			  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					th,\n					td {\n						text-align: center;\n					}\n			  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				td {\n					&:not(:last-child) {\n						border-right: 1px solid var(--line-color);\n					}\n				}\n			"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				th,\n				td {\n					&:not(:last-child) {\n						border-right: 1px solid var(--line-color);\n					}\n				}\n			"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	border-top: ",
        ";\n	th,\n	td {\n		position: relative;\n		height: 60px;\n		border-bottom: 1px solid var(--line-color);\n		font-size: var(--default-size);\n		font-weight: normal;\n		vertical-align: middle;\n		word-break: keep-all;\n\n		h1,\n		h2,\n		h3,\n		h4,\n		h5 {\n			font-size: var(--default-size);\n			color: var(--emp-color);\n		}\n	}\n\n	th {\n		background: ",
        ";\n		color: var(--emp-color);\n	}\n\n	",
        "\n\n	",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Table = styled_components_browser_esm["default"].table.withConfig({
    componentId: "sc-609bb036-0"
})(_templateObject4(), function(props) {
    return props.lineTop ? "1px solid var(--emp-color);" : "none;";
}, function(props) {
    return props.background ? "var(--disabled-color)" : "#fff";
}, function(props) {
    return props.types === "basic" ? (0,styled_components_browser_esm.css)(_templateObject()) : (0,styled_components_browser_esm.css)(_templateObject1());
}, function(props) {
    if (props.line && props.types === "basic") {
        return (0,styled_components_browser_esm.css)(_templateObject2());
    }
    if (props.line && props.types === "vertical") {
        return (0,styled_components_browser_esm.css)(_templateObject3());
    }
});
var TableContainer = function(param) {
    var _types = param.types, types = _types === void 0 ? "basic" : _types, children = param.children, _lineTop = param.lineTop, lineTop = _lineTop === void 0 ? true : _lineTop, _line = param.line, line = _line === void 0 ? true : _line, _background = param.background, background = _background === void 0 ? true : _background;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
        types: types,
        lineTop: lineTop,
        line: line,
        background: background,
        children: children
    });
};
/* harmony default export */ var table_Table = (TableContainer);

;// CONCATENATED MODULE: ./framework/ui/desktop/table/index.ts



/***/ }),

/***/ 81499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yq": function() { return /* reexport */ text_Accessibility; },
  "IW": function() { return /* binding */ BlueText; },
  "mH": function() { return /* binding */ Ellipsis; },
  "FA": function() { return /* reexport */ text_GuideText; },
  "mX": function() { return /* binding */ MinorTitle; },
  "xK": function() { return /* binding */ RedText; },
  "DK": function() { return /* binding */ SubTitle; },
  "Dx": function() { return /* binding */ Title; }
});

// UNUSED EXPORTS: EditorText

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./framework/ui/desktop/text/GuideText.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	font-size: var(--basic-size);\n	padding-left: 12px;\n	margin-top: ",
        ";\n	color: ",
        ';\n\n	&::before {\n		position: absolute;\n		top: 8px;\n		left: 0;\n		display: block;\n		width: 4px;\n		height: 4px;\n		border-radius: 50%;\n		background: var(--bl-color);\n		content: "";\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GuideText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-7128cc04-0"
})(_templateObject(), function(props) {
    return props.marginTop ? "15px" : "";
}, function(props) {
    return props.color ? props.color : "var(--default-color)";
});
/* harmony default export */ var text_GuideText = (GuideText);

;// CONCATENATED MODULE: ./framework/ui/desktop/text/Accessibility.tsx

function Accessibility_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	width: 1px;\n	height: 1px !important;\n	padding: 0;\n	margin: -1px;\n	border: none;\n	clip: rect(0 0 0 0);\n	overflow: hidden;\n"
    ]);
    Accessibility_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Accessibility = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-2deff0f5-0"
})(Accessibility_templateObject());
/* harmony default export */ var text_Accessibility = (Accessibility);

;// CONCATENATED MODULE: ./framework/ui/desktop/text/index.ts

function text_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--blue-color);\n"
    ]);
    text_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 15px;\n	color: var(--default-color);\n	line-height: 1.6;\n	word-break: keep-all;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--red-color);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-family: "PT-medium";\n	font-size: var(--title-size);\n	color: var(--emp-color);\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-family: "PT-medium";\n	font-size: var(--large-size);\n	color: var(--emp-color);\n	line-height: var(--large-size);\n'
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-family: "PT-medium";\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var BlueText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-41378efe-0"
})(text_templateObject());
var EditorText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-41378efe-1"
})(_templateObject1());
var Ellipsis = function(line) {
    return "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: ".concat(line, ";\n    -webkit-box-orient: vertical;\n");
};
var RedText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-41378efe-2"
})(_templateObject2());
var Title = styled_components_browser_esm["default"].h2.withConfig({
    componentId: "sc-41378efe-3"
})(_templateObject3());
var SubTitle = styled_components_browser_esm["default"].h3.withConfig({
    componentId: "sc-41378efe-4"
})(_templateObject4());
var MinorTitle = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-41378efe-5"
})(_templateObject5());



/***/ }),

/***/ 99653:
/***/ (function(module) {

module.exports = "/_next/static/images/ico_spr.66pUW1wQ.png";

/***/ })

}]);